export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6564.773956b4.jpg";